//=====================================================================
// Dropdown Menu
//=====================================================================
export const dropdownNavigation = (menu) => {
    
    const buttonSelector = '[data-dropdownButton]';
    const dropdowns = Array.from(menu.querySelectorAll('[data-dropdown]'));

    menu.addEventListener('click', (event) => {
        if (event.target.matches(buttonSelector)) window.addEventListener('click', runEvents);
    });
    
    function runEvents(event) {
        dropdowns.forEach(dropdown => {
            const button = dropdown.querySelector(buttonSelector);
            const closeButton = dropdown.querySelector('[data-dropdownClose]');

            if (event.target === button) {
                // Toggle the dropdown state when clicking the button
                if (dropdown.classList.contains('DDopen')) {
                    dropdown.classList.remove('DDopen');
                } else {
                    dropdown.classList.add('DDopen');
                }
            } else if (!dropdown.contains(event.target) || event.target === closeButton) {
                // Close the dropdown if the click is outside
                dropdown.classList.remove('DDopen');
            }
        });
        
        // Remove the event listener if no dropdown is open
        if (!dropdowns.some(dropdown => dropdown.classList.contains('DDopen'))) {
            window.removeEventListener('click', runEvents);
        }

        // Active focus on the searh on Freetype search
        if (event.target.matches('.lNav__link--search')) {
            const freetypeSearch = menu.querySelector('input.ais-SearchBox-input');
            if (!freetypeSearch) return;
            freetypeSearch.focus();
        }
    }
}